import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b7da92a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  style: {"margin":"1px 0px 1px 0px"},
  role: "separator"
}, null, -1))
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  style: {"margin":"1px 0px 1px 0px"},
  role: "separator"
}, null, -1))
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_totalizador_decorado = _resolveComponent("totalizador-decorado")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, {
    titulo: "RESUMO",
    class: "ss-card-alinhado",
    style: {"min-height":"96%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_spin, {
        spinning: _ctx.state.carregando
      }, {
        default: _withCtx(() => [
          (_ctx.props.tipo === _ctx.ETipoTituloFinanceiro.Pagar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", {
                      class: "ss-totalizador-financeiro-informativo",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filtrarTitulos('VencimentoHoje')))
                    }, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Visualizar os títulos a Pagar hoje."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_totalizador_decorado, {
                            titulo: "PAGAR HOJE",
                            cor: "#F7E811",
                            iconeColorido: true,
                            valor: _ctx.state.vencerHoje,
                            monetario: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: "ss-totalizador-financeiro-informativo",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filtrarTitulos('VencimentoMes')))
                    }, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Visualizar os títulos a Pagar esse mês."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_totalizador_decorado, {
                            titulo: "PAGAR ESSE MÊS",
                            cor: "#DCCE09",
                            iconeColorido: true,
                            valor: _ctx.state.vencerMes,
                            monetario: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: "ss-totalizador-financeiro-informativo",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filtrarTitulos('Atrasados')))
                    }, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Visualizar os títulos atrasados."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_totalizador_decorado, {
                            titulo: "ATRASADAS",
                            cor: "red",
                            iconeColorido: true,
                            valor: _ctx.state.vencidos,
                            monetario: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", {
                      class: "ss-totalizador-financeiro-informativo",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filtrarTitulos('BaixadosHoje')))
                    }, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Visualizar os títulos pagos hoje."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_totalizador_decorado, {
                            titulo: "PAGAS HOJE",
                            cor: "#93F711",
                            iconeColorido: true,
                            valor: _ctx.state.baixadosHoje,
                            monetario: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: "ss-totalizador-financeiro-informativo",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filtrarTitulos('BaixadosMes')))
                    }, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Visualizar os títulos pagos esse mês."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_totalizador_decorado, {
                            titulo: "PAGAS ESSE MÊS",
                            cor: "#8DC642",
                            iconeColorido: true,
                            valor: _ctx.state.baixadosMes,
                            monetario: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: "ss-totalizador-financeiro-informativo",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.filtrarTitulos('BaixadosAtrasdos')))
                    }, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Visualizar os títulos pagos esse mês que estavam atrasados em meses anteriores."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_totalizador_decorado, {
                            titulo: "PG. DE ATRASADAS ESSE MÊS",
                            iconeColorido: true,
                            cor: "#424BC6",
                            valor: _ctx.state.baixadosVencidos,
                            monetario: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", {
                      class: "ss-totalizador-financeiro-informativo",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filtrarTitulos('VencimentoHoje')))
                    }, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Visualizar os títulos a Receber hoje."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_totalizador_decorado, {
                            titulo: "RECEBER HOJE",
                            cor: "#F7E811",
                            iconeColorido: true,
                            valor: _ctx.state.vencerHoje,
                            monetario: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", {
                      class: "ss-totalizador-financeiro-informativo",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.filtrarTitulos('VencimentoMes')))
                    }, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Visualizar os títulos a Receber esse mês."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_totalizador_decorado, {
                            titulo: "RECEBER ESSE MÊS",
                            cor: "#DCCE09",
                            iconeColorido: true,
                            valor: _ctx.state.vencerMes,
                            monetario: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", {
                      class: "ss-totalizador-financeiro-informativo",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.filtrarTitulos('Atrasados')))
                    }, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Visualizar os títulos atrasados."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_totalizador_decorado, {
                            titulo: "ATRASADAS",
                            cor: "red",
                            iconeColorido: true,
                            valor: _ctx.state.vencidos,
                            monetario: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", {
                      class: "ss-totalizador-financeiro-informativo",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.filtrarTitulos('BaixadosHoje')))
                    }, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Visualizar os títulos recebidos hoje."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_totalizador_decorado, {
                            titulo: "RECEBIDAS HOJE",
                            cor: "#93F711",
                            iconeColorido: true,
                            valor: _ctx.state.baixadosHoje,
                            monetario: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", {
                      class: "ss-totalizador-financeiro-informativo",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.filtrarTitulos('BaixadosMes')))
                    }, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Visualizar os títulos recebidos esse mês."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_totalizador_decorado, {
                            titulo: "RECEBIDAS ESSE MÊS",
                            cor: "#8DC642",
                            iconeColorido: true,
                            valor: _ctx.state.baixadosMes,
                            monetario: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", {
                      class: "ss-totalizador-financeiro-informativo",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.filtrarTitulos('BaixadosAtrasdos')))
                    }, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Visualizar os títulos recebidos esse mês que estavam atrasados em meses anteriores."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_totalizador_decorado, {
                            titulo: "RECEB. ATRASADAS ESSE MÊS",
                            cor: "#424BC6",
                            iconeColorido: true,
                            valor: _ctx.state.baixadosVencidos,
                            monetario: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]))
        ]),
        _: 1
      }, 8, ["spinning"])
    ]),
    _: 1
  }))
}